import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeBwipCanvas } from '../../utils/bwip';

const Barcode = (props) => {
  const { code, scale = 3, height = 10, bcid = 'pdf417', label, bottomLabel, className, innerRef } = props;
  const [image, setImage] = useState();

  useMemo(async () => {
    const barcodeType = bcid === 'barcode' ? 'pdf417' : bcid;
    const bwipSettings = {
      bcid: barcodeType,
      text: code,
      scale,
      height,
    };

    if (barcodeType === 'qrcode') {
      bwipSettings.scale = 5;
      bwipSettings.height = 10;
      bwipSettings.width = 10;
    } else {
      bwipSettings.includetext = true;
      bwipSettings.textxalign = 'center';
    }

    const imgUrl = await makeBwipCanvas(bwipSettings);
    if (imgUrl) setImage(imgUrl);
  }, [code, scale, height, bcid]);

  return (
    <figure ref={innerRef} className={className} style={{ display: 'inline-block', margin: 0 }}>
      {label && <h3>{label}</h3>}
      <img src={image} style={{ maxWidth: '100%' }} />
      <figcaption style={{ textAlign: 'center' }}>{bottomLabel || code}</figcaption>
    </figure>
  );
};

Barcode.propTypes = {
  code: PropTypes.string.isRequired,
  scale: PropTypes.number,
  height: PropTypes.number,
  bcid: PropTypes.string,
  label: PropTypes.string,
};

export default React.forwardRef((props, ref) => <Barcode innerRef={ref} {...props} />);
